import(/* webpackMode: "eager" */ "/var/directorder/app/staging/apps/admin/src/app/(auth)/login/page.js");
